import { Role } from "./role";

const notifyUrl = (item) => {
    let url = '';
    switch (item.action) {
        case 'profile-update':
        case 'register':
        case 'change-email':
        case 'change-password':
        case 'deactivate-account':
        case 'block-user':
        case 'unblock-user':
        case 'password-reset-token':
        case 'upload-avatar':
        case 'upload-banner':
        default:
            url = ('User' === Role.Tutor) ? `/tutor/booking/${item.item_id}` : `/user/booking/${item.item_id}`;
    }
    return url;
};

export const urlHelper = {
    notifyUrl
};
